import React from "react";
import Overview from "../Overview/OverviewCard/Owerview/Owerview";
import FlinkGas from "./FlinkGas";
import FlinkCarbon from "./FlinkCarbon";
import FlinkElectricity from "./FlinkElectricity";
import FlinkForecast from "./FlinkForecast";
import FlinkOil from "./FlinkOil";
import FlinkPower from "./FlinkPower/FlinkPower";
import PdfPage from "../PdfPage/PdfPage";
import { logAction } from "../../core/services/logs";
import { useEffect } from "react";

export default function Content() {
  useEffect(() => {
    logAction("Cockpit", null);
  }, []);

  return (
    <div>
      <Overview />
      <PdfPage isHidden breakPage>
        <FlinkPower />
      </PdfPage>
      <PdfPage breakPage>
        <FlinkGas />
      </PdfPage>
      <PdfPage breakPage>
        <FlinkCarbon />
        <FlinkElectricity />
      </PdfPage>
      <PdfPage>
        <FlinkForecast />
        <FlinkOil />
      </PdfPage>
    </div>
  );
}
